import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {SecureFileGrid, Translate} from 'views/module';

const ContentView = (props) => {
  const bioQuestion = props.bioQuestion;
  const menuItems = props.extraFileMenuItems;

  const {questionData} = bioQuestion;

  if (questionData.value.length > 0) {
    return (
      <SecureFileGrid
        files={questionData.value}
        menuItems={menuItems}
      />
    );
  } else {
    return (
      <Box
        height={1}
      >
        <Translate expression='caregiver.CaregiverDetail.Biography.Questions.Empty' />
      </Box>

    );
  }
};

ContentView.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
  extraFileMenuItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    handler: PropTypes.func.isRequired,
    Icon: PropTypes.elementType,
    condition: PropTypes.func,
  })),
};

export default ContentView;
